import React, { Component } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import { Redirect, Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupPeriodoExamen } from '../PeriodoExamen/LookupPeriodoExamen';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';

registerLocale('es', es);

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class AddMesaExamen extends Component {
  static displayName = AddMesaExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: '',
      redirect: false,
      periodo: { codigo: 0, descripcion: '', fechaInicioPeriodo: new Date(), fechafinPeriodo: new Date() },
      materia: { materiaCodigo: '', materiaNombre: '' },
      showLookupMaterias: false,
      showLookupPeriodoCursada: false,
      fechaExamen: new Date(),
      fechaInicioInscripcion: new Date(),
      fechaFinInscripcion: new Date(),
      botonHabilitado: true,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWMesaExamen');
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupMaterias: false,
      materia: {
        materiaCodigo: carreraProperties[0],
        materiaNombre: carreraProperties[1].trim() + ' - ' + carreraProperties[2].trim() + ' - ' + carreraProperties[3].trim(),
      },
    });
  };

  handleSelectPeriodoCursadaItem = (e) => {
    const carreraProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupPeriodoCursada: false,
      periodo: {
        codigo: carreraProperties[0],
        descripcion: carreraProperties[1].trim() + ' - ' + carreraProperties[2].trim() + ' - ' + carreraProperties[3].trim(),
        fechaInicioPeriodo: carreraProperties[4],
        fechaFinPeriodo: carreraProperties[5],
      },
    });
  };

  handleFechaExamen = (date) => {
    this.clearFeedback();
    this.setState({ fechaExamen: date });
  };

  handleFechaInicioInscripcion = (date) => {
    this.clearFeedback();
    this.setState({ fechaInicioInscripcion: date });
  };

  handleFechaFinInscripcion = (date) => {
    this.clearFeedback();
    this.setState({ fechaFinInscripcion: date });
  };

  handleHideLookup = () => {
    this.setState({ showLookupMaterias: false });
  };

  handleHidePeriodoCursadaLookup = () => {
    this.setState({ showLookupPeriodoCursada: false });
  };

  handleShowCarreraLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupMaterias: true });
    }
  };

  handleShowPeriodoCursadaLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupPeriodoCursada: true });
    }
  };

  isOkToSave() {
    return this.state.materia.materiaCodigo.length > 0 && this.state.periodo.descripcion.length > 0;
  }

  datesInPeriodo() {
    return (
      (new Date(this.state.periodo.fechaInicioPeriodo) <= this.state.fechaExamen && new Date(this.state.periodo.fechaFinPeriodo) >= this.state.fechaExamen)
      && (new Date(this.state.periodo.fechaInicioPeriodo) <= this.state.fechaInicioInscripcion && new Date(this.state.periodo.fechaFinPeriodo) >= this.state.fechaInicioInscripcion)
      && (new Date(this.state.periodo.fechaInicioPeriodo) <= this.state.fechaFinInscripcion && new Date(this.state.periodo.fechaFinPeriodo) >= this.state.fechaFinInscripcion)
    );
  }

  datesOK() {
    return this.state.fechaInicioInscripcion <= this.state.fechaFinInscripcion && this.state.fechaFinInscripcion < this.state.fechaExamen;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;

    const okToSave = this.isOkToSave();
    const fechasOk = this.datesOK();
    const fechasEnPeriodo = true;

    if (okToSave && fechasOk && fechasEnPeriodo) {
      this.saveStudent();
      return;
    }

    let errorMessage = '';
    if (!okToSave) {
      errorMessage = 'Todos los campos son obligatorios';
    } else if (!fechasOk) {
      errorMessage = 'Compruebe las fechas ingresadas, las fechas de inscripción deben ser menor a la fecha del examen';
    }
    this.setState({ errorMessage });
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '', botonHabilitado: false });

    const { data } = await constantClass.apiFetch('api/mex', {
      method: 'POST',
      body: JSON.stringify({
        MesaExamenFechaExamen: constantClass.serializeDateForApi(this.state.fechaExamen),
        MesaExamenFechaInicioInscripci: constantClass.serializeDateForApi(this.state.fechaInicioInscripcion),
        MesaExamenFechaFinInscripcion: constantClass.serializeDateForApi(this.state.fechaFinInscripcion),
        PeridoExamenCod: this.state.periodo.codigo,
        MateriaCarreraCod: this.state.materia.materiaCodigo,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        botonHabilitado: true,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo guardar la mesa de examen. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true, botonHabilitado: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-mex" />;
    }

    const {
      loading,
      errorMessage,
      materia,
      periodo,
      fechaExamen,
      fechaInicioInscripcion,
      fechaFinInscripcion,
      showLookupMaterias,
      showLookupPeriodoCursada,
    } = this.state;
    const isBusy = loading;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-mex">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Nueva Mesa de Examen</h1>
        <p className="md-form-page__subtitle">
          Seleccione la materia, el período de examen y las fechas de inscripción y examen.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando mesa de examen, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Materia</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowCarreraLookup}
                disabled={isBusy}
              >
                Seleccione la Materia
              </button>
              {showLookupMaterias ? (
                <LookupMaterias selectItem={this.handleSelectCarreraItem} hideLookup={this.handleHideLookup} />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={materia.materiaNombre}
                placeholder="Materia seleccionada"
                readOnly
                disabled
                aria-label="Materia"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Período de Examen</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowPeriodoCursadaLookup}
                disabled={isBusy}
              >
                Seleccione el Período de Examen
              </button>
              {showLookupPeriodoCursada ? (
                <LookupPeriodoExamen
                  selectItem={this.handleSelectPeriodoCursadaItem}
                  hideLookup={this.handleHidePeriodoCursadaLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={periodo.descripcion}
                placeholder="Período seleccionado"
                readOnly
                disabled
                aria-label="Período de examen"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="mex-fecha-examen">
                Fecha de Examen
              </label>
              <DatePicker
                id="mex-fecha-examen"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={fechaExamen}
                onChange={this.handleFechaExamen}
                disabled={isBusy}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="mex-fecha-inicio-inscripcion">
                Fecha de Inicio de Inscripción
              </label>
              <DatePicker
                id="mex-fecha-inicio-inscripcion"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={fechaInicioInscripcion}
                onChange={this.handleFechaInicioInscripcion}
                disabled={isBusy}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="mex-fecha-fin-inscripcion">
                Fecha de Fin de Inscripción
              </label>
              <DatePicker
                id="mex-fecha-fin-inscripcion"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={fechaFinInscripcion}
                onChange={this.handleFechaFinInscripcion}
                disabled={isBusy}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
